import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

import { getNavigationItemProps } from './TabBarUtils';
import { styles } from './TabBar.styles';

export type ITabBarProps = {
  activeTab: ITab;
  tabs: ITab[];
  navigateToTab(tab: ITab): void;
};

export type ITab = {
  path: string;
  name: string;
};

export const TabBar: React.FC<ITabBarProps> = (props) => {
  const { activeTab, tabs, navigateToTab } = props;

  const activeIndex = tabs.findIndex((tab) => tab.name === activeTab?.name);
  const currentIndex = activeIndex === -1 ? 0 : activeIndex;

  return (
    <Tabs
      value={currentIndex}
      sx={styles.tabs}
    >
      {tabs.map((tab) => {
        const { isActive, name } = getNavigationItemProps(tab, activeTab);
        const dataTest = tab.path ? `${tab.path}-path` : 'nav-menu-path';
        return (
          <Tab
            key={name}
            label={name}
            data-test={dataTest}
            sx={isActive ? styles.activeTab : styles.tab}
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              event.preventDefault();
              if (!isActive) navigateToTab(tab);
            }}
          />
        );
      })}
    </Tabs>
  );
};
